/* eslint-disable */
class CartUpsell extends HTMLElement {
  constructor() {
    super();

    this.cartContainer = document.querySelector('#CartContainer')
    this.upsellDrawer = document.querySelector('[data-cart-upsell-item-drawer-back]');

    this.toggleButton = this.querySelector('[data-upsell-toggle]');
    this.content = this.querySelector('[data-upsell-content]');

    this.limit = this.dataset.limit
    this.count = this.dataset.count
  }

  connectedCallback() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', this.toggleWidget.bind(this))
    }
    if (this.upsellDrawer) {
      this.upsellDrawer.addEventListener('click', (e) => {
        e.preventDefault();
        this.cartContainer && this.cartContainer.classList.remove('show-upsell-drawer');
      })
    }
    this.randomizeUpsell();
  }

  toggleWidget(e) {
    e.preventDefault();
    if (this.classList.contains('opened')) {
      this.classList.remove('opened')
      $(this.content).slideUp();
      localStorage.setItem("cart-upsell-opened", "false");
    } else {
      this.classList.add('opened')
      $(this.content).slideDown();
      localStorage.setItem("cart-upsell-opened", "true");
    }
  }

  randomizeUpsell() {
    const array = this.randomNumbersArray(parseFloat(this.limit), parseFloat(this.count));
    array.map((index, i) => {
      const $target = $(this).find(`.upsell-item-wrap[data-index="${index}"]`);
      $target.removeClass('hide')
    })

    $(this.content).css('opacity', 1)
  }

  randomNumbersArray(length = 10, maxVal = 20) {
    let randomVals = [];
    const array = [...Array(maxVal).keys()].map(i => i + 1);
    for(let i = 0; i<maxVal; i++) {
      if (randomVals.length < length) {
        const num = Math.floor(Math.random() * (maxVal - randomVals.length)) - 1;
        const selected = array.splice(num, 1);
        randomVals.push(selected[0])
      }
    }

    return randomVals;
  }
}

if (!customElements.get('component-cart-upsell')) {
  customElements.define('component-cart-upsell', CartUpsell);
}

document.addEventListener('DOMContentLoaded', () => {
})

$('body').on('drawer-opt', () => {
  $.getJSON('/?sections=mini-cart', (cart) => {
    const miniCartHtml = cart['mini-cart'];
    const upsellElem = new DOMParser()
      .parseFromString(miniCartHtml, 'text/html')
      .querySelector('.cart-upsell-wrap')

    if (upsellElem) {
      $('#CartContainer .cart-upsell-wrap').html(upsellElem.innerHTML)
    }

    // Open Cart Upsell based on Localstorage
    const state = localStorage.getItem("cart-upsell-opened")
    if (state == 'true') {
      $('#CartContainer component-cart-upsell').addClass('opened');
      $('#CartContainer [data-upsell-content]').css('display', 'block')
    } else if (state != null) {
      $('#CartContainer component-cart-upsell').removeClass('opened');
      $('#CartContainer [data-upsell-content]').css('display', 'none')
    }

    //klarna refresh
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  });
})